import { useState } from 'react';

import GenericPropertyInput from '../../../FlowDesigner/Components/Inputs/GenericPropertyInput';
import { MenuOptionModel } from '../../Models/MenuOptionModel';
import GenericPropertyInputRefContent from './MenuInputContent';
import { MenuInputDialog } from './MenuInputDialog';

type MenuInputProps = {
	menu: MenuOptionModel | undefined;
	onMenuChange: (menu: MenuOptionModel | undefined) => void;
	isEditable?: boolean;
};

export default function MenuInput({ menu, onMenuChange, isEditable = true }: MenuInputProps) {
	const [open, setOpen] = useState(false);

	// In non-edit mode, just show the menu title
	if (!isEditable) {
		return <GenericPropertyInputRefContent value={menu} />;
	}

	return (
		<GenericPropertyInput value={menu} onValueChange={onMenuChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={menu} />
			{open && <MenuInputDialog open={open} setOpen={setOpen} menu={menu} onMenuChange={onMenuChange} />}
		</GenericPropertyInput>
	);
}
